import React, { useState, useEffect, useMemo } from "react";
import ClickPointSelector from "views/components/visualizations/OnClickPopover/ClickPointSelector";
import ValueActionsDropdown from "views/components/visualizations/OnClickPopover/ValueActionsDropdown";
import { AdditionalContext } from "views/logic/ActionContext";
import useQueryFieldTypes from "views/hooks/useQueryFieldTypes";
const defaultMetricMapper = (clickPoint) => {
  var _a, _b;
  return {
    value: `${String((_a = clickPoint.text) != null ? _a : clickPoint.y)}`,
    metric: (_b = clickPoint.data.originalName) != null ? _b : clickPoint.data.name
  };
};
const DropdownSwitcher = ({
  component: Component,
  clickPoint,
  config,
  clickPointsInRadius = [],
  metricMapper = defaultMetricMapper,
  onPopoverClose
}) => {
  var _a;
  const [step, setStep] = useState(null);
  const [selectedClickPoint, setSelectedClickPoint] = useState();
  const [fieldData, setFieldData] = useState(null);
  const types = useQueryFieldTypes();
  const onSelect = (pt) => {
    setSelectedClickPoint(pt);
    setStep("values");
  };
  const hasPointsInRadius = useMemo(() => {
    const len = clickPointsInRadius == null ? void 0 : clickPointsInRadius.length;
    return !!len && len > 1;
  }, [clickPointsInRadius]);
  useEffect(() => {
    setSelectedClickPoint(clickPoint);
    setStep(!hasPointsInRadius ? "values" : "traces");
    setFieldData(null);
  }, [clickPoint, clickPointsInRadius, hasPointsInRadius]);
  const additionalContextValue = useMemo(
    () => {
      var _a2;
      return {
        valuePath: (_a2 = fieldData == null ? void 0 : fieldData.contexts) == null ? void 0 : _a2.valuePath,
        fieldTypes: types
      };
    },
    [(_a = fieldData == null ? void 0 : fieldData.contexts) == null ? void 0 : _a.valuePath, types]
  );
  const onValueSelect = (data) => {
    setStep("actions");
    setFieldData(data);
  };
  const onActionRun = () => {
    onPopoverClose();
    setFieldData(null);
    setStep(null);
  };
  if (!selectedClickPoint) return null;
  if (step === "traces")
    return /* @__PURE__ */ React.createElement(ClickPointSelector, { clickPointsInRadius, metricMapper, onSelect });
  if (step === "values")
    return /* @__PURE__ */ React.createElement(
      Component,
      {
        clickPoint: selectedClickPoint,
        config,
        setFieldData: onValueSelect,
        showBackButton: hasPointsInRadius,
        setStep
      }
    );
  if (step === "actions")
    return /* @__PURE__ */ React.createElement(AdditionalContext.Provider, { value: additionalContextValue }, /* @__PURE__ */ React.createElement(
      ValueActionsDropdown,
      {
        setStep,
        field: fieldData.field,
        value: fieldData.value,
        onActionRun
      }
    ));
  return null;
};
export default DropdownSwitcher;
